import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { routeModifierInfoSchema } from '../schemas/route-modifier-info';

/**
 * Get avoid favors for the given avoid favor set IDs
 * @param setIds Array of avoid favor set IDs
 * @returns Array of avoid favors
 */
export function getAvoidFavorSetsRouteModifiers(
  this: unknown,
  setIds: number[]
) {
  const params = new URLSearchParams();
  setIds.forEach((setId) => {
    params.append('avoidfavorSets', setId.toString());
  });
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${fleetEnvironment.resolve(this).avoidFavorSetsRouteModifiersUrl}?${params.toString()}`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(selectData(z.array(routeModifierInfoSchema)));
}
